import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { ensureType as s } from "../symbols.js";
import { JSONMap as t } from "../core/jsonMap.js";
import { clone as o } from "../core/lang.js";
import r from "../core/Logger.js";
import { isNone as i, unwrapOr as a, unwrap as l } from "../core/maybe.js";
import { property as n } from "../core/accessorSupport/decorators/property.js";
import { cast as u } from "../core/accessorSupport/decorators/cast.js";
import { enumeration as c } from "../core/accessorSupport/decorators/enumeration.js";
import { reader as p } from "../core/accessorSupport/decorators/reader.js";
import { subclass as m } from "../core/accessorSupport/decorators/subclass.js";
import { writer as d } from "../core/accessorSupport/decorators/writer.js";
import { ensureType as h, ensureString as f, ensureNumber as y } from "../core/accessorSupport/ensureType.js";
import { collectArcadeFieldNames as g, collectField as b } from "../layers/support/fieldUtils.js";
import x from "./Renderer.js";
import { VisualVariablesMixin as k } from "./mixins/VisualVariablesMixin.js";
import v from "./support/ClassBreakInfo.js";
import { rendererBackgroundFillSymbolProperty as I, rendererSymbolProperty as B } from "./support/commonProperties.js";
import S from "./support/LegendOptions.js";
import { loadArcade as V } from "../support/arcadeOnDemand.js";

var _F;

var E = r.getLogger("esri.renderers.ClassBreaksRenderer"),
    j = "log",
    w = "percent-of-total",
    z = "field",
    T = new t({
  esriNormalizeByLog: j,
  esriNormalizeByPercentOfTotal: w,
  esriNormalizeByField: z
}),
    _ = h(v);

var C = _F = /*#__PURE__*/function (_k) {
  _inherits(F, _k);

  var _super = _createSuper(F);

  function F(e) {
    var _this;

    _classCallCheck(this, F);

    _this = _super.call(this, e), _this._compiledValueExpression = {
      valueExpression: null,
      compiledFunction: null
    }, _this.backgroundFillSymbol = null, _this.classBreakInfos = null, _this.defaultLabel = null, _this.defaultSymbol = null, _this.field = null, _this.isMaxInclusive = !0, _this.legendOptions = null, _this.normalizationField = null, _this.normalizationTotal = null, _this.type = "class-breaks", _this.valueExpression = null, _this.valueExpressionTitle = null, _this._set("classBreakInfos", []);
    return _this;
  }

  _createClass(F, [{
    key: "readClassBreakInfos",
    value: function readClassBreakInfos(e, s, t) {
      if (!Array.isArray(e)) return;
      var o = s.minValue;
      return e.map(function (e) {
        var s = new v();
        return s.read(e, t), null == s.minValue && (s.minValue = o), null == s.maxValue && (s.maxValue = s.minValue), o = s.maxValue, s;
      });
    }
  }, {
    key: "writeClassBreakInfos",
    value: function writeClassBreakInfos(e, s, t, o) {
      var r = e.map(function (e) {
        return e.write({}, o);
      });
      this._areClassBreaksConsecutive() && r.forEach(function (e) {
        return delete e.classMinValue;
      }), s[t] = r;
    }
  }, {
    key: "castField",
    value: function castField(e) {
      return null == e ? e : "function" == typeof e ? (E.error(".field: field must be a string value"), null) : f(e);
    }
  }, {
    key: "minValue",
    get: function get() {
      return this.classBreakInfos && this.classBreakInfos[0] && this.classBreakInfos[0].minValue || 0;
    }
  }, {
    key: "normalizationType",
    get: function get() {
      var e = this._get("normalizationType");

      var s = !!this.normalizationField,
          t = null != this.normalizationTotal;
      return s || t ? (e = s && z || t && w || null, s && t && E.warn("warning: both normalizationField and normalizationTotal are set!")) : e !== z && e !== w || (e = null), e;
    },
    set: function set(e) {
      this._set("normalizationType", e);
    }
  }, {
    key: "addClassBreakInfo",
    value: function addClassBreakInfo(e, t, r) {
      var i = null;
      i = "number" == typeof e ? new v({
        minValue: e,
        maxValue: t,
        symbol: s(r)
      }) : _(o(e)), this.classBreakInfos.push(i), 1 === this.classBreakInfos.length && this.notifyChange("minValue");
    }
  }, {
    key: "removeClassBreakInfo",
    value: function removeClassBreakInfo(e, s) {
      var t = this.classBreakInfos.length;

      for (var _o = 0; _o < t; _o++) {
        var _t = [this.classBreakInfos[_o].minValue, this.classBreakInfos[_o].maxValue];

        if (_t[0] === e && _t[1] === s) {
          this.classBreakInfos.splice(_o, 1);
          break;
        }
      }
    }
  }, {
    key: "getBreakIndex",
    value: function getBreakIndex(e, s) {
      return this.valueExpression && (i(s) || i(s.arcade)) && E.warn(""), this.valueExpression ? this._getBreakIndexForExpression(e, s) : this._getBreakIndexForField(e);
    }
  }, {
    key: "getClassBreakInfo",
    value: function () {
      var _getClassBreakInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, s) {
        var t, o;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = s;
                _context.t0 = this.valueExpression && (i(s) || i(s.arcade));

                if (!_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.t1 = _objectSpread;
                _context.t2 = _objectSpread({}, t);
                _context.t3 = {};
                _context.next = 8;
                return V();

              case 8:
                _context.t4 = _context.sent;
                _context.t5 = {
                  arcade: _context.t4
                };
                t = (0, _context.t1)(_context.t2, _context.t3, _context.t5);

              case 11:
                o = this.getBreakIndex(e, t);
                return _context.abrupt("return", -1 !== o ? this.classBreakInfos[o] : null);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getClassBreakInfo(_x, _x2) {
        return _getClassBreakInfo.apply(this, arguments);
      }

      return getClassBreakInfo;
    }()
  }, {
    key: "getSymbol",
    value: function getSymbol(e, s) {
      if (this.valueExpression && (i(s) || i(s.arcade))) return void E.error("#getSymbol()", "Please use getSymbolAsync if valueExpression is used");
      var t = this.getBreakIndex(e, s);
      return t > -1 ? this.classBreakInfos[t].symbol : this.defaultSymbol;
    }
  }, {
    key: "getSymbolAsync",
    value: function () {
      var _getSymbolAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, s) {
        var t, _e, _s, o;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = s;

                if (!(this.valueExpression && (i(s) || i(s.arcade)))) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 4;
                return V();

              case 4:
                _e = _context2.sent;
                _s = _e.arcadeUtils;
                _context2.t0 = _s.hasGeometryOperations(this.valueExpression);

                if (!_context2.t0) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return _s.enableGeometryOperations();

              case 10:
                t = _objectSpread(_objectSpread({}, t), {}, {
                  arcade: _e
                });

              case 11:
                o = this.getBreakIndex(e, t);
                return _context2.abrupt("return", o > -1 ? this.classBreakInfos[o].symbol : this.defaultSymbol);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSymbolAsync(_x3, _x4) {
        return _getSymbolAsync.apply(this, arguments);
      }

      return getSymbolAsync;
    }()
  }, {
    key: "getSymbols",
    value: function getSymbols() {
      var e = [];
      return this.classBreakInfos.forEach(function (s) {
        s.symbol && e.push(s.symbol);
      }), this.defaultSymbol && e.push(this.defaultSymbol), e;
    }
  }, {
    key: "getAttributeHash",
    value: function getAttributeHash() {
      return this.visualVariables && this.visualVariables.reduce(function (e, s) {
        return e + s.getAttributeHash();
      }, "");
    }
  }, {
    key: "getMeshHash",
    value: function getMeshHash() {
      var e = JSON.stringify(this.backgroundFillSymbol),
          s = JSON.stringify(this.defaultSymbol),
          t = "".concat(this.normalizationField, ".").concat(this.normalizationType, ".").concat(this.normalizationTotal);
      return "".concat(e, ".").concat(s, ".").concat(this.classBreakInfos.reduce(function (e, s) {
        return e + s.getMeshHash();
      }, ""), ".").concat(t, ".").concat(this.field, ".").concat(this.valueExpression);
    }
  }, {
    key: "arcadeRequired",
    get: function get() {
      return this.arcadeRequiredForVisualVariables || !!this.valueExpression;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _F({
        field: this.field,
        backgroundFillSymbol: this.backgroundFillSymbol && this.backgroundFillSymbol.clone(),
        defaultLabel: this.defaultLabel,
        defaultSymbol: this.defaultSymbol && this.defaultSymbol.clone(),
        valueExpression: this.valueExpression,
        valueExpressionTitle: this.valueExpressionTitle,
        classBreakInfos: o(this.classBreakInfos),
        isMaxInclusive: this.isMaxInclusive,
        normalizationField: this.normalizationField,
        normalizationTotal: this.normalizationTotal,
        normalizationType: this.normalizationType,
        visualVariables: o(this.visualVariables),
        legendOptions: o(this.legendOptions),
        authoringInfo: this.authoringInfo && this.authoringInfo.clone()
      });
    }
  }, {
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, s) {
        var t;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = [this.collectVVRequiredFields(e, s), this.collectSymbolFields(e, s)];
                _context3.next = 3;
                return Promise.all(t);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function collectRequiredFields(_x5, _x6) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }, {
    key: "collectSymbolFields",
    value: function () {
      var _collectSymbolFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, s) {
        var t;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = [].concat(_toConsumableArray(this.getSymbols().map(function (t) {
                  return t.collectRequiredFields(e, s);
                })), [g(e, s, this.valueExpression)]);
                b(e, s, this.field);
                b(e, s, this.normalizationField);
                _context4.next = 5;
                return Promise.all(t);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function collectSymbolFields(_x7, _x8) {
        return _collectSymbolFields.apply(this, arguments);
      }

      return collectSymbolFields;
    }()
  }, {
    key: "_getBreakIndexForExpression",
    value: function _getBreakIndexForExpression(e, s) {
      var _a = a(s, {}),
          t = _a.viewingMode,
          o = _a.scale,
          r = _a.spatialReference,
          i = _a.arcade;

      var n = this._compiledValueExpression.valueExpression === this.valueExpression ? this._compiledValueExpression.compiledFunction : null;
      var u = l(i).arcadeUtils;

      if (!n) {
        var _e2 = u.createSyntaxTree(this.valueExpression);

        n = u.createFunction(_e2), this._compiledValueExpression.compiledFunction = n;
      }

      this._compiledValueExpression.valueExpression = this.valueExpression;
      var c = u.executeFunction(n, u.createExecContext(e, u.getViewInfo({
        viewingMode: t,
        scale: o,
        spatialReference: r
      })));
      return this._getBreakIndexfromInfos(c);
    }
  }, {
    key: "_getBreakIndexForField",
    value: function _getBreakIndexForField(e) {
      var s = this.field,
          t = e.attributes,
          o = this.normalizationType;
      var r = parseFloat(t[s]);

      if (o) {
        var _e3 = this.normalizationTotal,
            _s2 = parseFloat(t[this.normalizationField]);

        if (o === j) r = Math.log(r) * Math.LOG10E;else if (o !== w || isNaN(_e3)) {
          if (o === z && !isNaN(_s2)) {
            if (isNaN(r) || isNaN(_s2)) return -1;
            r /= _s2;
          }
        } else r = r / _e3 * 100;
      }

      return this._getBreakIndexfromInfos(r);
    }
  }, {
    key: "_getBreakIndexfromInfos",
    value: function _getBreakIndexfromInfos(e) {
      var s = this.isMaxInclusive;
      if (null != e && "number" == typeof e && !isNaN(e)) for (var _t2 = 0; _t2 < this.classBreakInfos.length; _t2++) {
        var _o2 = [this.classBreakInfos[_t2].minValue, this.classBreakInfos[_t2].maxValue];
        if (_o2[0] <= e && (s ? e <= _o2[1] : e < _o2[1])) return _t2;
      }
      return -1;
    }
  }, {
    key: "_areClassBreaksConsecutive",
    value: function _areClassBreaksConsecutive() {
      var e = this.classBreakInfos,
          s = e.length;

      for (var _t3 = 1; _t3 < s; _t3++) {
        if (e[_t3 - 1].maxValue !== e[_t3].minValue) return !1;
      }

      return !0;
    }
  }]);

  return F;
}(k(x));

e([n(I)], C.prototype, "backgroundFillSymbol", void 0), e([n({
  type: [v]
})], C.prototype, "classBreakInfos", void 0), e([p("classBreakInfos")], C.prototype, "readClassBreakInfos", null), e([d("classBreakInfos")], C.prototype, "writeClassBreakInfos", null), e([n({
  type: String,
  json: {
    write: !0
  }
})], C.prototype, "defaultLabel", void 0), e([n(B)], C.prototype, "defaultSymbol", void 0), e([n({
  type: String,
  json: {
    write: !0
  }
})], C.prototype, "field", void 0), e([u("field")], C.prototype, "castField", null), e([n({
  type: Boolean
})], C.prototype, "isMaxInclusive", void 0), e([n({
  type: S,
  json: {
    write: !0
  }
})], C.prototype, "legendOptions", void 0), e([n({
  type: Number,
  readOnly: !0,
  value: null,
  json: {
    read: !1,
    write: {
      overridePolicy: function overridePolicy() {
        return 0 !== this.classBreakInfos.length && this._areClassBreaksConsecutive() ? {
          enabled: !0
        } : {
          enabled: !1
        };
      }
    }
  }
})], C.prototype, "minValue", null), e([n({
  type: String,
  json: {
    write: !0
  }
})], C.prototype, "normalizationField", void 0), e([n({
  type: Number,
  cast: function cast(e) {
    return y(e);
  },
  json: {
    write: !0
  }
})], C.prototype, "normalizationTotal", void 0), e([n({
  type: T.apiValues,
  value: null,
  json: {
    type: T.jsonValues,
    read: T.read,
    write: T.write
  }
})], C.prototype, "normalizationType", null), e([c({
  classBreaks: "class-breaks"
})], C.prototype, "type", void 0), e([n({
  type: String,
  json: {
    write: !0
  }
})], C.prototype, "valueExpression", void 0), e([n({
  type: String,
  json: {
    write: !0
  }
})], C.prototype, "valueExpressionTitle", void 0), C = _F = e([m("esri.renderers.ClassBreaksRenderer")], C);
var N = C;
export { N as default };